
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PDCClearanceGrid extends _Ext.GridBase<PDCClearanceRow, any> {
        protected getColumnsKey() { return 'Finance.PDCClearance'; }
        protected getDialogType() { return PDCClearanceDialog; }
        protected getIdProperty() { return PDCClearanceRow.idProperty; }
        protected getInsertPermission() { return PDCClearanceRow.insertPermission; }
        protected getLocalTextPrefix() { return PDCClearanceRow.localTextPrefix; }
        protected getService() { return PDCClearanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var userDefinition = Q.Authorization.userDefinition;
            var voucherNo = FormatHelper.GetVoucherNo(9);
            this.editItem(<PDCClearanceRow>{
                VoucherNo: voucherNo,
                TransDate: now.toString(),
                CreatedBy: userDefinition.UserId,
                VoucherTypeId: 9,
                FinancialYearId: userDefinition.FinancialYearId,
                CompanyId: userDefinition.CompanyId

            });
        }
    }
}